import PermissionWrapper from "features/Permission/PermissionWrapper";
import { Action } from "features/Permission/types";
import { LoginLocations } from "features/userLoginHistory/Locations";
import {
  fetchAllLoginHistory,
  fetchLoginHistory,
} from "features/userLoginHistory/service/loginHistoryService";
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { SearchFilters } from "features/userLoginHistory/components/SearchFilters";
import { convertToTimestamp } from "features/userLoginHistory/utils";

export function UserLoginHistoryPage() {
  const [searchTerm, setSearchTerm] = useState("");
  const [dateRange, setDateRange] = useState<{
    from?: string | Date;
    to?: string | Date;
  }>({
    from: new Date(new Date().setHours(0, 0, 0, 0)),
    to: new Date(new Date().setHours(23, 59, 59, 999)),
  });
  const [allLoginHistory, setAllLoginHistory] = useState([]);
  const [filteredLoginHistory, setFilteredLoginHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleReset = () => {
    setSearchTerm("");
    setDateRange({
      from: new Date(new Date().setHours(0, 0, 0, 0)),
      to: new Date(new Date().setHours(23, 59, 59, 999)),
    });
    setFilteredLoginHistory(allLoginHistory);
  };

  const handleSearch = async () => {
    setIsLoading(true);
    try {
      const data = await fetchLoginHistory({
        startTimestamp: convertToTimestamp(dateRange.from?.toString()),
        endTimestamp: convertToTimestamp(dateRange.to?.toString()),
        userId: searchTerm || undefined,
      });
      setFilteredLoginHistory(data);
    } catch (error) {
      console.error("Error fetching login history:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    fetchAllLoginHistory().then((data) => {
      setAllLoginHistory(data);
      setFilteredLoginHistory(data);
      setIsLoading(false);
    });
  }, []);

  return (
    <>
      <div className="mb-4">
        <h2 className="text-2xl font-bold text-gray-800">Login History</h2>
        <SearchFilters
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          dateRange={dateRange}
          setDateRange={setDateRange}
          loginHistoryData={allLoginHistory}
          isLoading={isLoading}
          onSearch={handleSearch}
          onReset={handleReset}
        />
      </div>
      <PermissionWrapper
        actions={[Action.VIEW_USER_LOGIN_HISTORY]}
        fallback={<Navigate to="/dashboard" replace />}
      >
        <LoginLocations
          loginData={filteredLoginHistory}
          isLoading={isLoading}
        />
      </PermissionWrapper>
    </>
  );
}
